export const TYPEFORM_URL_REGEX =
  /^https:\/\/([A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?).typeform.com\/to\/([^?]*)(\?.*)?$/
export const TYPEFORM_URL_FORM_ID_MATCH_INDEX = 2
